export type objects =
  | 'Home'
  | 'Setting'
  | 'AppSetting'
  | 'DashboardSetting'
  | 'Wallet'
  | 'Address'
  | 'Layout'
  | 'Device'
  | 'ScrapingOrder'
  | 'PurchaseOrder'
  | 'OrderNote'
  | 'Deposit'
  | 'ScrapingCart'
  | 'Advertisement'
  | 'User'
  | 'MainSectionCategory'
  | 'Group'
  | 'MainSection'
  | 'ScrapingItem'
  | 'Product'
  | 'Outfit'
  | 'Transaction'
  | 'DriverTransactions'
  | 'Report'
  | 'Offer'
  | 'PaymentMethod'
  | 'PaymentMethodDiscount'
  | 'Notification'
  | 'PromoCode'
  | 'CartOffer'
  | 'SocialLink'
  | 'Driver'
  | 'Admin'
  | 'Team'
  | 'Refund'
  | 'RefundRequest'
  | 'OrderComplaint'
  | 'OrderComplaintReason'
  | 'Warehouse'
  | 'Shipment'
  | 'Receiving'
  | 'Sorting'
  | 'OrderPacking'
  | 'WarehouseArrival'
  | 'ShipToIraq'
  | 'ReadyToSort'
  | 'WarehouseScan'
  | 'CartonType'
  | 'ShippingCompany'
  | 'Carton'
  | 'Manifest'
  | 'Bin'
  | 'BinAdmin'
  | 'WarehouseException'
  | 'ItemLabel'
  | 'Repackaging'
  | 'Category'
  | 'Message'
  | 'Automation'
  | 'Province'
  | 'Governorate'
  | 'District'
  | 'subDistrict'
  | 'City'
  | 'DriverAreaAssignment'
  | 'TryOnAi'
  | 'OrderStateGroup'
  | 'ScreenMessage'
  | 'OrderStatusArrangement'
  | 'ShippingRate'
  | 'BusinessSetting'
  | 'ERP'
  | 'PIM'
  | 'CMS'
  | 'OMS'
  | 'TimeSheets'
  | 'Attendacne'
  | 'TimeOff'
  | 'Employees'
  | 'Recruitement'
  | 'Management'
  | 'TimeLeave'
  | 'HumanResources'
  | 'all';

export enum objectsEnum {
  'Home',
  'Setting',
  'AppSetting',
  'DashboardSetting',
  'Wallet',
  'Address',
  'Layout',
  'Device',
  'ScrapingOrder',
  'PurchaseOrder',
  'OrderNote',
  'Deposit',
  'ScrapingCart',
  'Advertisement',
  'User',
  'MainSectionCategory',
  'Group',
  'MainSection',
  'ScrapingItem',
  'Product',
  'Outfit',
  'Transaction',
  'Report',
  'Offers',
  'PaymentMethod',
  'PaymentMethodDiscount',
  'Notification',
  'PromoCode',
  'CartOffer',
  'SocialLink',
  'Driver',
  'Admin',
  'Team',
  'Refund',
  'RefundRequest',
  'OrderComplaint',
  'OrderComplaintReason',
  'Warehouse',
  'Shipment',
  'Receiving',
  'Sorting',
  'OrderPacking',
  'WarehouseArrival',
  'ShipToIraq',
  'ReadyToSort',
  'CartonType',
  'ShippingCompany',
  'Carton',
  'Manifest',
  'Bin',
  'BinAdmin',
  'WarehouseException',
  'ItemLabel',
  'Category',
  'Message',
  'Automation',
  'OrderStateGroup',
  'ScreenMessage',
  'all',
}

export enum abilitiesEnum {
  'Read',
  'Create',
  'Update',
  'Delete',
}

export const initialAbilities = ['read', 'create', 'update', 'delete'];

export const permissionsList = [
  { label: 'Home', value: 'Home' },
  { label: 'Scraping Orders', value: 'ScrapingOrder' },
  { label: 'Purchase Order', value: 'PurchaseOrder' },
  { label: 'Order Notes', value: 'OrderNote' },
  { label: 'Order Delivery Notes', value: 'Deposit' },
  { label: 'Scraping Cart', value: 'ScrapingCart' },
  { label: 'Advertisements', value: 'Advertisement' },
  { label: 'Customers', value: 'User' },
  { label: 'Main Section Categories', value: 'MainSectionCategory' },
  { label: 'Groups', value: 'Group' },
  { label: 'Main Sections', value: 'MainSection' },
  { label: 'Scraping Item', value: 'ScrapingItem' },
  { label: 'Product', value: 'Product' },
  { label: 'Layout', value: 'Layout' },
  { label: 'Outfit', value: 'Outfit' },
  { label: 'Transactions', value: 'Transaction' },
  { label: 'Reports', value: 'Report' },
  { label: 'Payment Methods', value: 'PaymentMethod' },
  { label: 'Payment Method Discounts', value: 'PaymentMethodDiscount' },
  { label: 'Promo Codes', value: 'PromoCode' },
  { label: 'Cart Offers', value: 'CartOffer' },
  { label: 'Notifications', value: 'Notification' },
  // Watcher
  { label: 'Watcher Messages', value: 'Message' },
  { label: 'Watcher Automations', value: 'Automation' },
  { label: 'Social Links', value: 'SocialLink' },
  { label: 'Drivers', value: 'Driver' },
  { label: 'Admins', value: 'Admin' },
  { label: 'Team', value: 'Team' },
  { label: 'Warehouses', value: 'Warehouse' },
  { label: 'Shipments', value: 'Shipment' },
  { label: 'Receiving', value: 'Receiving' },
  { label: 'Sorting', value: 'Sorting' },
  { label: 'Order Packing', value: 'OrderPacking' },
  { label: 'Warehouse Arrival', value: 'WarehouseArrival' },
  { label: 'Ship to Iraq', value: 'ShipToIraq' },
  { label: 'Ready to Sort', value: 'ReadyToSort' },
  { label: 'Carton Types', value: 'CartonType' },
  { label: 'Shipping Companies', value: 'ShippingCompany' },
  { label: 'Cartons', value: 'Carton' },
  { label: 'Manifests', value: 'Manifest' },
  { label: 'Bins', value: 'Bin' },
  { label: 'Bin Admin', value: 'BinAdmin' },
  { label: 'Warehouse Problems', value: 'WarehouseException' },
  { label: 'Item Labels', value: 'ItemLabel' },
  { label: 'Categories', value: 'Category' },
  { label: 'Refunds', value: 'Refund' },
  { label: 'Order Complaints', value: 'OrderComplaint' },
  { label: 'Complaint Reasons', value: 'OrderComplaintReason' },
  { label: 'Provinces', value: 'Province' },
  { label: 'Governorates', value: 'Governorate' },
  { label: 'Cities', value: 'City' },
  { label: 'Districts', value: 'District' },
  { label: 'Subdistricts', value: 'subDistrict' },
  { label: 'Areas', value: 'DriverAreaAssignment' },
  { label: 'TRYON', value: 'TryOnAi' },
  { label: 'Order State Groups', value: 'OrderStateGroup' },
  { label: 'Order Status Arrangement', value: 'OrderStatusArrangement' },
  { label: 'Shipping Rates', value: 'ShippingRate' },
  { label: 'Screen Messages', value: 'ScreenMessage' },
  // {label: "Driver Transactions", value: "DriverTransactions"},
  { label: 'Wallets', value: 'Wallet' },
  { label: 'Address', value: 'Address' },
  // {label: "Settings", value: "Setting"},
];

export const initialPermission = {
  object: permissionsList[0].value,
  abilities: ['read'],
};

export type initialPermissiontype = typeof initialPermission;

export const initialErrors = {
  firstName: String() || null,
  lastName: String() || null,
  phoneNumber: String() || null,
  email: String() || null,
  password: String() || null,
  permissions: String() || null,
};

export const initialAdmin = {
  firstName: String(),
  lastName: String(),
  phoneNumber: String(),
  email: String(),
  password: String(),
  permissions: [initialPermission],
};

export type initialAdminType = typeof initialAdmin;
export type initialErrorsType = typeof initialErrors;
export type initialPermissionsType = (typeof initialPermission)[];

export const adminsTableHead = [
  {
    id: 'name',
    numeric: true,
    label: 'Name',
  },
  {
    id: 'phoneNumber',
    numeric: true,
    label: 'Phone Number',
  },
  {
    id: 'state',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'CreatedAt',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];
